// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  ItemFormEntry,
  itemFormSchema,
  validateItemFormEntries,
} from '@/orders/schemas/item';
import { ShipmentItem } from '@/shipment/api/types';
import { extractSparseItem } from '@/sparse/utilities/to-sparse-item';

// Re-export shared schema and utilities for shipment dialogs
export {
  itemFormSchema as partOrProductItemSchema,
  validateItemFormEntries as validateShipmentItems,
};

/**
 * Type definition for a shipment form item.
 */
type ShipmentFormItem = ItemFormEntry;

/**
 * Default empty item for initializing shipment form item arrays.
 */
export const defaultShipmentFormItem: ShipmentFormItem = {
  item: null,
  quantity: null,
};

/**
 * Converts shipment items from API response format to form format.
 * Shipment items use nested structure with item properties under `item` field.
 */
export function mapShipmentItemsToFormItems(
  items: ShipmentItem[]
): ShipmentFormItem[] {
  return items.map((lineItem) => ({
    item: extractSparseItem(lineItem),
    quantity: lineItem.quantity,
  }));
}
